import { motion } from 'framer-motion';
import aboutImg from '../assets/IMG_0503.jpg';
import teamImg  from '../assets/IMG_0490.jpg';
import styles from './About.module.css';

const CHIPS = ['Bridal Specialist', 'Nationally Certified', 'Destination Weddings', '25+ Years Experience'];

const reveal = (delay = 0) => ({
  initial: { opacity: 0, y: 32 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.25 },
  transition: { duration: 0.85, delay, ease: [0.16, 1, 0.3, 1] },
});

export default function About() {
  return (
    <section id="about" className={styles.about}>
      <div className={styles.inner}>

        {/* ── Left: stacked images ── */}
        <div className={styles.images}>
          <motion.div
            className={styles.imgMain}
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
          >
            <img src={aboutImg} alt="Shobha Ma'am at Hair Revolution event — nationally recognised makeup artist, Bharatpur" />
          </motion.div>

          <motion.div
            className={styles.imgSecondary}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 1, delay: 0.18, ease: [0.16, 1, 0.3, 1] }}
          >
            <img src={teamImg} alt="Shobha Salon team — Bharatpur's most trusted beauty professionals" />
            <div className={styles.imgBadge}>
              <span className={styles.badgeStar}>★</span>
              <span className={styles.badgeText}>4.8 Rated</span>
            </div>
          </motion.div>

          {/* Decorative gold corner */}
          <div className={styles.cornerAccent} aria-hidden="true" />
        </div>

        {/* ── Right: text ── */}
        <div className={styles.text}>
          <motion.span className={styles.eyebrow} {...reveal(0.05)}>
            About Shobha Ma'am
          </motion.span>

          <motion.h2 className={styles.heading} {...reveal(0.12)}>
            The Art of Making You <em>Unforgettable</em>
          </motion.h2>

          <motion.div className={styles.body} {...reveal(0.22)}>
            <p>
              Shobha Ma'am has spent over two decades perfecting the craft of beauty
              in Bharatpur. What began as a passion became the city's most trusted name
              in makeup artistry, skincare, and bridal transformations.
            </p>
            <p>
              Clients travel from across Rajasthan. When the occasion demands it, Shobha
              Ma'am travels to them, to palaces, hotels and heritage venues across India.
            </p>
            <p><strong>Nationally certified. Deeply personal. Consistently flawless.</strong></p>
          </motion.div>

          <motion.div className={styles.chips} {...reveal(0.32)}>
            {CHIPS.map(c => <span key={c} className={styles.chip}>{c}</span>)}
          </motion.div>

          <motion.a href="#gallery" className={styles.cta} {...reveal(0.42)}>
            See the Work →
          </motion.a>
        </div>
      </div>
    </section>
  );
}
